<div class="h-full">
  <hm-appointments-list
    [clientUserId]="memberProfile().userId"
    [withPatientName]="false"
    [withSearch]="true"
  ></hm-appointments-list>
</div>
